import { withBreakpoint } from 'contest/components/breakpoints';

export default function withExpandedUI(WrappedComponent) {
    return withBreakpoint(WrappedComponent, breakpoint => ({
        isExpandedUI: ['normal', 'large'].includes(breakpoint),
    }));
}



// WEBPACK FOOTER //
// ./src/web/js/contest/components/expanded-ui.jsx